export const it_dashboard = {
    mappatura: 'mappatura',
    scan_di_mercato: 'scan di mercato',
    mapped_build: 'Immobili Mappati',
    new_auction: 'Aste Inserite',
    operations: 'Operazioni in corso',
    closed_operations: 'Operazioni concluse',
    cash_flow: 'Capitale Iniziale',
    last_30_days_subtitle: 'negli ultimi 30 giorni',
    operations_charts_1: 'Andamento attività',
    operations_charts_2: 'Mappature/Mq',
    cashflow: 'Il tuo capitale iniziale',
    cashflow_label: 'Ti servirà come promemoria per le tue operazioni',

    popover_archive_title: 'Le tue attività',
    popover_archive_content: '<p>In questa card è possibile valutare l’andamento delle operazioni inserite e valutare il livello di attività del lavoro in base al tempo.</p>',
    descrizione_mappatura: '<p>Puoi mappare subito tuoi immobili attraverso le piattaforme <strong>immobiliare.it</strong> e <strong>idealista.it</strong> <br>ed individuare velocemente le operazioni da approfondire. </p>',
    citta: 'Citta*',
    zona: 'Zona*',
    macro_zona: 'Macro zona',
    micro_zona: 'Micro zona',
    salva_disegna: 'salva e disegna la zona',
    acquista_pacchetto: 'acquista il pacchetto',
    rimuovi_autorizzazione: 'rimuovi autorizzazione',
    aggiungi_evento: 'aggiungi l\'evento',
    attiva_calendar: 'attiva il tuo google calendar',
    in_analisi: 'in analisi',
    in_corso: 'in corso',
    chiuse: 'chiuse',
    nessuno: 'nessuno',
    annuncio_portale: 'annuncio sul portale',
    conto_economico: 'conto economico',
    sb_mappatura_scan: 'Mappatura e Scan',
    sb_archivio_mappatura: 'Archivio mappatura',
    sb_mie_operazioni: 'Le mie operazioni',
    sb_mio_team: 'My Team',
    sb_mio_task: 'My Task',
    sb_pillole_immobiliari: 'Pillole immobiliari',
    sb_proponi_idea: 'Proponi un\'idea',
    sb_novita: 'Novità',
		check_link_enable: 'Attiva',
		check_link_disable: 'Disattiva',
		torna_al_sito_ufficiale: 'Torna al sito ufficiale',
		torna_area_coach: 'Torna all\'area coach',
		check_link_modal_title: 'controllo automatico link scaduti',
        check_link_modal_subtitle: 'Versione BETA',
		check_link_modal_description: 'Gestisci in modo automatico la cancellazione degli immobili scaduti presenti nella tua lista importata.',
    check_link_modal_alert: 'Questa opzione è valida solo per il portale <strong>immobiliare.it</strong>' +
        '<br>Il servizio - una volta attivato - avrà effetto sull\'archivio dopo 48 ore circa.<br>' +
        'Se all\'annuncio è collegato un Conto Economico <strong>non verrà cancellato</strong> (nè l\'annuncio, nè il conto economico).',
		check_link_modal_cancel: 'Chiudi',
        sb_trash:'Cestino immobili'
};
